import { useState } from 'react';
import { InlineNotification } from '@carbon/react';

interface TitleValidatorDevNoticeProps {
  /** Positioning override for the host location. */
  className?: string;
}

export function TitleValidatorDevNotice({
  className,
}: TitleValidatorDevNoticeProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <InlineNotification
      kind="info"
      lowContrast
      title="Notice"
      subtitle="This tool is under active development, improvements coming soon. Features are being refined and results may contain errors, please hold off on using it for decision making until further notice."
      className={className}
      onCloseButtonClick={() => setIsVisible(false)}
    />
  );
}
